import React from 'react'
import './Abtcont.css'
import { FaChevronRight } from 'react-icons/fa6'

function Abtcont() {
  return (
    <section className='abtcont'>
        <div className='container'>
            <h3>Ready for the next step in your <br/> digital transformation?</h3>
            <p>Let's transform your customer experience.</p>
            <button className='btn-main' onClick={() => window.location.href = '/contact'}><span>Contact Us</span> <FaChevronRight/></button>
        </div>
    </section>
  )
}

export default Abtcont
